// import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader

import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import themeFile from '@/assets/themes';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  // TODO: list, in a comment, all the available themes
  theme: {
    options: { cspNonce: '3vYRvBYgnvzm0zwU' },
    themes: {
      /* Themes so far:
      * blueberry
      * blanket (bleh)
      * leaf
      * mojito
      * peppermint
      * candy
      */
      light: themeFile.bluejito,
    },
  },
});
